import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';
import classNames from 'clsx';
import Validator from 'arbitrip-common/client/utils/Validator';

const BillingSection = ({ billingEmail, onBillingEmailChange, onBillingFieldBlur, disabled, validationEnabled }) => {
    const { t } = useTranslation();

    const isEmailValid = !validationEnabled || !billingEmail || Validator.validateEmailAddress(billingEmail);
    const isEmailEmpty = validationEnabled && !billingEmail;

    return (
        <div className="billing-section">
            <div className="title">{t('Billing.Title')}</div>
            <div className="subtitle">{t('Billing.InvoiceEmailSubheader')}</div>
            <div className="billing-email-field">
                <label htmlFor="billing-email-input">{t('Billing.EmailAddress')}</label>
                <TextField
                    id="billing-email-input"
                    className={classNames('field-input', (!isEmailValid || isEmailEmpty) && 'error')}
                    fullWidth
                    value={billingEmail}
                    onChange={(e) => onBillingEmailChange(e.target.value.trim())}
                    onBlur={(e) => onBillingFieldBlur?.(e)}
                    disabled={disabled}
                    data-testid="billing-email-input"
                />
                {isEmailEmpty && (
                    <div className="error-message">
                        <span>{t('Billing.EmailRequired')}</span>
                    </div>
                )}
                {!isEmailValid && !isEmailEmpty && (
                    <div className="error-message">
                        <span>{t('Billing.EmailInvalid')}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

BillingSection.propTypes = {
    billingEmail: PropTypes.string.isRequired,
    onBillingEmailChange: PropTypes.func.isRequired,
    onBillingFieldBlur: PropTypes.func,
    disabled: PropTypes.bool,
    validationEnabled: PropTypes.bool,
};

export default BillingSection;
